import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetExtraService } from "./useGetExtraService"
import { ExtraServiceEntity } from "../../Objects/ExtraService/ExtraServiceEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSaveExtraService = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetExtraService } = useGetExtraService()

  const handleSavesExtraService = async (extraServiceChange: ExtraServiceEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = null

      if (extraServiceChange.id !== -1) {
        response = await PutFormRequest(
          `${API_ROUTES.EXTRA_SERVICE.PUT}/${extraServiceChange.id}`,
          extraServiceChange.toJSON(),
        )
      } else {
        response = await PostFormRequest(API_ROUTES.EXTRA_SERVICE.CREATE, extraServiceChange.toJSON())
      }

      if (response.success) {
        await handleGetExtraService(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesExtraService,
  }
}
